<div class="layout-footer">
  <h6>
    {{ constants.footerMessage }}
  </h6>
</div>
